/**
 * Décide si l’UI doit proposer le choix tour joker / circuit principal.
 * En solo, la pause est locale (`pendingMove`). En partie serveur, seule
 * l’autorité (`serverPendingPlayerIndex`) compte : le client n’a pas de
 * reprise de budget locale.
 */
export interface JokerLapChoiceGateInput {
  raceActive: boolean;
  isMovingToken: boolean;
  choice: boolean | null;
  currentPlayerIndex: number;
  pendingMove: { playerIndex: number; remainingBudget: number } | null;
  isMultiplayer: boolean;
  serverPendingPlayerIndex: number | null;
}

export function needsJokerLapEntryChoiceForUi(input: JokerLapChoiceGateInput): boolean {
  if (!input.raceActive || input.isMovingToken || input.choice != null) return false;

  const pending = input.pendingMove;
  if (
    pending != null &&
    pending.remainingBudget > 0 &&
    input.currentPlayerIndex === pending.playerIndex
  ) {
    return true;
  }

  return (
    input.isMultiplayer &&
    input.serverPendingPlayerIndex != null &&
    input.serverPendingPlayerIndex === input.currentPlayerIndex
  );
}
